import React from "react";
import "./offline.css";

function Offline() {
	return (
		<div className="offline">
			<h1>
				Videti je, da ste izgubili internetno povezavo.
			</h1>
			<p>
				Prosimo, da se povežete na internet in osvežite stran.
			</p>
		</div>
	);
}

export default Offline;
